import React, { useEffect, useRef, useState} from 'react'

/*
  params:
    id: unique id that is guranteed to be unique (fieldname is not unique enough)
    fieldName: textarea field name for form_editor to retrieve answer
    readOnly: bool for read only mode. In readonly, top toolbar is hidden
    updateAnswer: callback for form_editor to get aswers from texarea
    wordLimit: int 0 to disable. Hard limited to this amount
    placeholder
    defaultValue: Prefilled answer
*/

const RichTextEditor = ({id, fieldname, readOnly, updateAnswer, wordLimit, placeholder, defaultValue, value: propValue, preview, className = ''}) => {
  const [value, setValue] = useState(propValue || defaultValue)
  const editorRef = useRef(null);

  function tinymce_updateWordCounter(el, len) {
    const ed = $('#wrapper-' + id ).find(".textarea-counter-count").find('.label')
    ed.find('.current').text(len);
    if (len >= el.settings.max_words) {
      ed.addClass("label-info")
    } else {
      if (ed.hasClass("label-info")) { ed.removeClass("label-info") }
    }
  }

  function tinymce_getContentLength() {
      const text = tinyMCE.get(id).contentDocument.body.innerText
      if (text == '\n' || tinyMCE.get(id).contentDocument.body.innerHTML.includes('id="placeholder"')) {return 0}
      const result = text.split(/\s+/);
      return result.length
  }

  useEffect(() => {
    if (propValue != value) {
      setValue(propValue);
      if (tinyMCE.activeEditor) {
        tinyMCE.activeEditor.setContent(propValue || '');
      }
    }

  }, [propValue]);

  useEffect(() => {
    if (propValue != value) {
      updateAnswer(value);
    }
  }, [value]);

  useEffect(()=>{
    // Create hr component with customization
    tinymce.PluginManager.add('hrcustom', function (editor, url) {
      editor.addButton('hrcustom', {
          icon: 'hr',
          tooltip: I18n.t('insert_horizontal_rule'),
          onclick: function() {
              // open window
              editor.windowManager.open({
                  title: I18n.t('insert_horizontal_rule'),
                  body: [
                      { 
                          type: 'listbox', 
                          name: 'align', 
                          label: 'Alignment', 
                          values: [
                              { value: 'left', text: I18n.t('left') },
                              { value: 'center', text: I18n.t('center') },
                              { value: 'right', text: I18n.t('right') }
                          ] 
                      },
                      {
                          type: 'colorbox',
                          name: 'color',
                          label: 'Color',
                          onaction: createColorPickerAction(),
                          value: '#000000'
                      },
                      {
                          type: 'textbox',
                          name: 'width',
                          label: 'Width',
                          maxLength: 5,
                          value: '100%'
                      }, 
                      {
                          type: 'listbox',
                          name: 'height',
                          label: 'Level',
                          maxLength: 5,
                          values: [
                            { value: '1px', text: '1' },
                            { value: '3px', text: '2' },
                            { value: '5px', text: '3' },
                            { value: '7px', text: '4' },
                            { value: '7px', text: '5' },
                        ] 
                      }
                  ],
                  // generate and insert HTML upon submitting dialog 
                  onsubmit: function (e) {
                      var hr = document.createElement('hr');
                      // set alignment
                      switch (e.data.align) {
                          case 'center':
                              hr.style.marginLeft = 'auto';
                              hr.style.marginRight = 'auto';
                              break;
                          case 'right':
                              hr.style.textAlign = 'right';
                              hr.style.marginRight = 0;
                              break;
                          default:
                              hr.style.textAlign = 'left';
                              hr.style.marginLeft = 0;
                              break;
                      }
                      // set color
                      hr.style.backgroundColor = e.data.color || '#000000';
                      var unitRegex = /^\d+(px|%)?$/;
                      // set width
                      hr.style.width = unitRegex.test(e.data.width) ? e.data.width : '100%';
                      // set height (thickness)
                      hr.style.height = unitRegex.test(e.data.height) ? e.data.height : '1px';
                      // set other styles
                      hr.style.border = 0;
                      hr.style.marginTop = '5px';
                      hr.style.marginBottom = '5px';
                      hr.style.overflow = 'hidden';
                      // insert content when the window form is submitted
                      editor.insertContent(hr.outerHTML);
                  }
              });
          }
      });
  
      // colorpicker plugin MUST be included for this to work

      function createColorPickerAction() {
          var callback = tinymce.activeEditor.settings.color_picker_callback;
          if (callback) {
              return function () {
                  var self = this;
                  callback.call(
                      editor,
                      function (value) {
                          self.value(value).fire('change');
                      },
                      self.value()
                  );
              }
          }
      }
  });
    TinyMCEHelper.init({
      target: editorRef.current,
      plugins: [
        "wordcount lists paste autoresize textcolor colorpicker hrcustom"
      ],
      autoresize_bottom_margin: 10,
      autoresize_max_height: 500,
      autoresize_min_height: 100,
      menu: {},
      toolbar: readOnly ? false : 'bold italic underline bullist numlist forecolor hrcustom',
      statusbar: false,
      relative_urls : false,
      remove_script_host : false,
      readonly: readOnly ? 1 : 0,
      max_words: wordLimit || 100, 

      setup: function (ed) {
        ed.on('blur', function (e) {
          setValue(tinyMCE.activeEditor.save())
        });

        if (placeholder) {

          ed.on('init', function(){
            // Add placeholder
            if (tinyMCE.get(id).getContent() == '' || $('#wrapper-' + this.id ).find('iframe').contents().find('#placeholder').length == 1){
              tinyMCE.get(id).setContent("<p id='placeholder' style='color: #b2b2b2' >" + placeholder + "</p>");
            }
          });

          ed.on('focus',function(){
            // Remove placeholder
            if ($('#wrapper-' + this.id ).find('iframe').contents().find('#placeholder').length == 1){
              tinyMCE.get(id).setContent('')
            }
          });
        }

        if (wordLimit != 0) {

          ed.on('keydown', function (e) {
            // If spacebar pressed and worlimit would be reached
            if (e.keyCode == 32 && tinymce_getContentLength() + 1 > this.settings.max_words) {
              return false
            }
            return true
          });

          ed.on('keyup', function (e) {
            tinymce_updateWordCounter(this, tinymce_getContentLength());
          })
        }
      },

      init_instance_callback: function () {
        // Force input value to Tinymce
        // Tinymce doesn't init if you visit a page via a link with Turbo enable
        if (value != '') {
          $('#wrapper-' + this.id).find('iframe').contents().find('body').html(value);
        }

        // Create counter div
        // css copied from stylesheets as mce overwrites every rule on every child element
        if (wordLimit != 0) {
          $('#wrapper-' + this.id ).find('.mce-top-part').after('<span class="textarea-counter-count" style=""><span class="label label-default" style="background-color: #9b9898; padding: .1em .6em .3em; border-top-right-radius: 0px; margin-right: 0px; margin-top: 0px;"><div style="font-size: 75%; font-weight: 700; line-height: 1; color: #fff; text-align: center; white-space: nowrap; font-family: Roboto, Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif; "><span class="current" style="font-size: 100%; font-weight: 700; line-height: 1; color: #fff; text-align: center; white-space: nowrap; font-family: Roboto, Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif; " >0</span> / '+this.settings.max_words + ' ' + I18n.t('words') + '</div></span></span>');
          tinymce_updateWordCounter(this, tinymce_getContentLength());
        }

        if (readOnly && !preview) {
          tinyMCE.get(id).getBody().style.backgroundColor = '#eeeeee'
          tinyMCE.get(id).getBody().style.opacity = '1'
        }
        tinyMCE.get(id).getBody().style.color = '#555555'
        tinyMCE.get(id).getBody().style.fontSize = '14'
      },
      
      paste_preprocess: function (plugin, args) {
        // Limit pasting too big text
        if (wordLimit != 0) {
          var editor = tinymce.get(tinymce.activeEditor.id);
          var len = tinymce_getContentLength()
          var textLen = args.content.split(/\s+/).length;
          if (len + textLen > editor.settings.max_words) {
              alert(I18n.t('paste_too_long', {scope: 'fe'}));
              args.content = '';
          } else {
            tinymce_updateWordCounter(editor, len + textLen);
          }
        }
      },
      
    })

    return function cleanup() {
      if (tinyMCE.get(id)) {
        tinyMCE.get(id).destroy();
      }
    }
  
  }, [readOnly, wordLimit, placeholder, fieldname, id, preview])

  return (
    <div id={'wrapper-' + id} className={`rich-text-editor ${className}`}>
      <textarea readOnly name={fieldname} id={id} ref={editorRef} value={value} />
    </div>
  )
}

export default RichTextEditor
